import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "edit-person" }
const _hoisted_2 = {
  key: 1,
  class: "person-content"
}
const _hoisted_3 = { class: "bottom" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loader = _resolveComponent("Loader")
  const _component_ContactTile = _resolveComponent("ContactTile")
  const _component_RolesSelector = _resolveComponent("RolesSelector")
  const _component_TrackerSegment = _resolveComponent("TrackerSegment")
  const _component_TrackerSlider = _resolveComponent("TrackerSlider")
  const _component_TrackerButtongroup = _resolveComponent("TrackerButtongroup")
  const _component_TrackerTextarea = _resolveComponent("TrackerTextarea")
  const _component_ScrollBar = _resolveComponent("ScrollBar")
  const _component_Divider = _resolveComponent("Divider")
  const _component_Icon = _resolveComponent("Icon")
  const _component_Button = _resolveComponent("Button")
  const _component_TrackerDelete = _resolveComponent("TrackerDelete")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($options.loading)
      ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          ($props.head)
            ? (_openBlock(), _createBlock(_component_ContactTile, {
                key: 0,
                class: "person-info",
                name: $data.contact.name,
                position: $data.contact.position,
                avatar: $data.contact.avatar_url,
                company: $data.company
              }, null, 8 /* PROPS */, ["name", "position", "avatar", "company"]))
            : _createCommentVNode("v-if", true),
          _createVNode(_component_ScrollBar, {
            class: "settings",
            "bar-x-offset": "-2rem"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_TrackerSegment, { title: "buying role(s)" }, {
                default: _withCtx(() => [
                  _createVNode(_component_RolesSelector, {
                    modelValue: $data.contact.tracker_roles,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.contact.tracker_roles) = $event))
                  }, null, 8 /* PROPS */, ["modelValue"])
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_TrackerSegment, {
                title: "TRACKER SENSITIVITY",
                tooltip: "signal_sensitivity"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_TrackerSlider, {
                    modelValue: $options.slider_focus,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($options.slider_focus) = $event)),
                    class: "slider",
                    step: 50,
                    "show-tooltip": false,
                    greyed: $options.focus_text
                  }, null, 8 /* PROPS */, ["modelValue", "greyed"])
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_TrackerSegment, {
                title: "EMAIL ALERTS",
                tooltip: "email_notifications"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_TrackerButtongroup, {
                    modelValue: $data.contact.tracker_alerts,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.contact.tracker_alerts) = $event)),
                    options: $data.alerts,
                    class: "button-group"
                  }, null, 8 /* PROPS */, ["modelValue", "options"])
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_TrackerSegment, {
                title: "WHAT SHOULD WE WATCH FOR?",
                tooltip: "contact_customize_tracking"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_TrackerTextarea, {
                    modelValue: $data.contact.focus_on,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.contact.focus_on) = $event)),
                    title: "Focus tracking on:",
                    class: "textarea",
                    placeholder: "Track product launches, partnerships, and executive changes."
                  }, null, 8 /* PROPS */, ["modelValue"])
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_Divider, { m: "0 -2.4rem 2.4rem" }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Button, {
              class: "delete-button",
              disabled: $options.saving,
              onClick: $options.openDeleteModal
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Icon, {
                  icon: "trash-2",
                  size: "1.5rem",
                  stroke: "var(--error-500)"
                }),
                _cache[4] || (_cache[4] = _createTextVNode(" Delete Tracker "))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["disabled", "onClick"]),
            _createVNode(_component_Button, {
              primary: "",
              disabled: !$options.can_save,
              loading: $options.saving,
              onClick: $options.onSave
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("Save")
              ])),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["disabled", "loading", "onClick"])
          ]),
          _createVNode(_component_TrackerDelete, {
            ref: "delete",
            onDeleted: $options.onDeleted
          }, null, 8 /* PROPS */, ["onDeleted"])
        ]))
  ]))
}